export enum AnimationState {
  NONE,
  PLAYING,
  STOPPED
}
